// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__jUpTQ","description":"PatientConsentPreview_description__2i9K0"};